module.exports = __webpack_public_path__ + "static/media/play.57577be6.svg";